import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/cp4i-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`IBM Cloud Pak for Integration is a hybrid integration solution that provides an automated and closed-loop lifecycle across multiple styles of enterprise integration.`}</p>
    <p>{`Use the Labs below to demonstrate the Cloud Pak for Integration capabilities.`}</p>
    <p><strong parentName="p">{`CP4I Labs on ROKS`}</strong></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/tutorials/BuildDeployAPIs"
      }}>{`Lab 1 : Build and Deploy APIs - APIC/ACE/MQ`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/tutorials/AccessBackendSystems"
      }}>{`Lab 2 : Access backend systems using APIs and Messaging - ACE/MQ`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/tutorials/CreateEngagingExperiences"
      }}>{`Lab 3 : Augment existing business functions using Kafka - ACE/ES`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/tutorials/ManageGraphQL"
      }}>{`Lab 4 : GraphQL API Lifecycle Management`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      